import { render, staticRenderFns } from "./AccordionRecipe.vue?vue&type=template&id=3ccda474"
import script from "./AccordionRecipe.vue?vue&type=script&lang=js"
export * from "./AccordionRecipe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports